import VueCompositionAPI, { computed } from "@vue/composition-api";
import Vue from "vue";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";

Vue.use(VueCompositionAPI);

const questionaryInfoFieldsConfig = computed(() => [
  {
    name: "about",
    label: $t("Bio"),
    type: "rich-textarea",
    fieldMeta: { allowedForMember: true, description: true },
  },
  {
    name: "website",
    label: $t("Website"),
    fieldMeta: { allowedForMember: true, url: true, regExp: /^http(s)?:\/\/(?:www\.)?/, appendText: "http://" },
  },
  {
    name: "facebook",
    label: $t("Facebook"),
    appendIcon: "sci-facebook-dark",
    fieldMeta: {
      social: true,
      site: "https://facebook.com/",
      regExp: /(?:(?:https?:\/\/)?.*facebook\.com\/)?([^/?]+)/,
    },
  },
  {
    name: "twitter",
    label: $t("Twitter"),
    appendIcon: "sci-twitter-dark",
    fieldMeta: {
      social: true,
      site: "https://twitter.com/",
      regExp: /(?:(?:https?:\/\/)?.*twitter\.com\/)?([^/?]+)/,
    },
  },
  {
    name: "instagram",
    label: $t("Instagram"),
    appendIcon: "sci-instagram-dark",
    fieldMeta: {
      social: true,
      site: "https://instagram.com/",
      regExp: /(?:(?:https?:\/\/)?.*instagram\.com\/|@?)?([^/?]+)/,
    },
  },
  {
    name: "tiktok",
    label: $t("TikTok"),
    appendIcon: "sci-tik-tok-dark",
    fieldMeta: {
      social: true,
      site: "https://tiktok.com/@",
      regExp: /(?:(?:https?:\/\/)?.*tiktok\.com\/@)?([^/?]+)/,
    },
  },
  {
    name: "youtube",
    label: $t("YouTube"),
    appendIcon: "sci-youtube-dark",
    fieldMeta: {
      social: true,
      site: "https://youtube.com/",
      regExp: /(?:(?:https?:\/\/)?.*youtube\.com\/)?([^*]+)/,
    },
  },
  {
    name: "snapchat",
    label: $t("Snapchat"),
    appendIcon: "sci-snapchat-dark",
    fieldMeta: {
      social: true,
      site: "https://snapchat.com/add/",
      regExp: /(?:(?:https?:\/\/)?.*snapchat\.com\/add\/)?([^/?]+)/,
    },
  },
  {
    name: "patreon",
    label: $t("Patreon"),
    appendIcon: "sci-patreon-dark",
    fieldMeta: {
      social: true,
      site: "https://patreon.com/",
      regExp: /(?:(?:https?:\/\/)?.*patreon\.com\/)?([^/?]+)/,
    },
  },
  {
    name: "onlyfans",
    label: $t("OnlyFans"),
    appendIcon: "sci-only-fans-dark",
    fieldMeta: {
      social: true,
      site: "https://onlyfans.com/",
      regExp: /(?:(?:https?:\/\/)?.*onlyfans\.com\/|@?)?([^/?]+)/,
    },
  },
  {
    name: "linkedin",
    label: $t("LinkedIn"),
    appendIcon: "sci-linkedin-dark",
    fieldMeta: {
      social: true,
      site: "https://linkedin.com/in/",
      regExp: /(?:(?:https?:\/\/)?.*linkedin\.com\/in\/)?([^/?]+)/,
    },
  },
  {
    name: "amazonWishlist",
    label: $t("Wish List URL"),
    appendIcon: "sci-amazon-dark",
    fieldMeta: {
      amazon: true,
      url: true,
      regExp: /^http(s)?:\/\/(?:www\.)?/,
      appendText: "http://",
      logo: "sci-amazon-logo-dark",
    },
  },
  {
    name: "calendar",
    label: $t("Calendar"),
    appendIcon: "sci-calendar-dark",
    fieldMeta: {
      calendar: true,
      url: true,
      regExp: /^http(s)?:\/\/(?:www\.)?/,
      appendText: "http://",
      logo: "sci-calendar-dark",
    },
  },
]);

export const getQuestionaryInfoFields = () => {
  return questionaryInfoFieldsConfig.value.filter(
    i => (config.questionaryHiddenField as string[]).indexOf(i.name) === -1
  );
};
